import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const MapContainer = (props) => {
  const { lat, lng, maxHeight, maxWidth } = props;
  console.log(props, "props%%%%%%%%%%");

  // Convert lat and lng to numbers if they are passed as strings
  const latitude = Number(lat);
  const longitude = Number(lng);

  if (isNaN(latitude) || isNaN(longitude)) {
    console.error('Invalid latitude or longitude');
    return null; // or handle the error accordingly
  }


  const containerStyle = {
    width: maxWidth || '100%',
    height: maxHeight || '100%',
  };

  return (
    <LoadScript googleMapsApiKey="AIzaSyBajhVyi8KbuKuEPk1osx9M_7qmpg8e1-c">
      <GoogleMap
        mapContainerStyle={containerStyle}
        zoom={14}
        center={{ lat: latitude, lng: longitude }}
      >
        <Marker position={{ lat: latitude, lng: longitude }} />
      </GoogleMap>
    </LoadScript>
  );
};

export const getAddressFromLatLng = async (lat, lng) => {
  const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyBajhVyi8KbuKuEPk1osx9M_7qmpg8e1-c`);
  const data = await response.json();
  if (data?.status === 'OK') {
    const address = data?.results[0]?.formatted_address;
    return address;
  } else {
    console.log(data?.status);
  }
};

export default MapContainer;
